<template lang="pug">

div

    .ui.field.error.message {{ validation.firstError('type') }}

    //- Typ
    .grouped.fields

        //- Auftraggeber
        .field
            .ui.toggle.checkbox
                input(type="checkbox" id="purchaser" v-model="isPurchaser")
                label(for="purchaser") Auftraggeber

        //- Lieferant
        .field
            .ui.toggle.checkbox
                input(type="checkbox" id="supplier" v-model="isSupplier")
                label(for='supplier') Lieferant

        //- Agentur
        .field
            .ui.toggle.checkbox
                input(type="checkbox" id="agency" v-model="isAgency")
                label(for="agency") Agentur
  

    //- Zahlungsziel
    number-field(
        label='Zahlungsziel in Tagen'
        v-model='paymentTargetDays'
        v-bind:is-required='true'
        v-bind:min='1'
        v-show="isPurchaser"
    )
        field-error(v-bind:validation='validation' attribute='paymentTargetDays')

    //- E-Mail für Datenanlieferung
    text-field(label='E-Mail für Datenanlieferung' v-model='dataDeliveryEmail' v-bind:is-required='true' v-if="isSupplier")
        field-error(v-bind:validation='validation' attribute='dataDeliveryEmail')

    //- Zahlungsfrist
    number-field(
        label='Zahlungsfrist in Tagen'
        v-model='paymentDeadlineDays'
        v-bind:is-required='true'
        v-bind:min='1'
        v-show="isSupplier"
    )
        field-error(v-bind:validation='validation' attribute='paymentDeadlineDays')
    
    //- Vorkasse
    .field(v-show="isPurchaser")
        .ui.toggle.checkbox
            input(type="checkbox" id="prepayment" v-model="isPrepayment")
            label(for="prepayment") Vorkasse

    //- Gehoert als Agentur zu Unternehmen
    multi-dropdown-field(
        label='Gehört als Agentur zu'
        v-bind:options='companyModels'
        v-model='agencyCompanies'
        v-show='isAgency'
        v-bind:observe-changes='false'
    )

</template>

<script>
    import * as R from 'ramda'
    import { Validator } from 'simple-vue-validator'
    import FieldError from '@/components/form/SmartFieldError.vue'
    import MultiDropdownField from '@/components/form/MultiDropdownField.vue'
    import NumberField from '@/components/form/NumberField.vue'
    import TextareaField from '@/components/form/TextareaField.vue'
    import TextField from '@/components/form/TextField.vue'

    //noinspection JSUnusedGlobalSymbols
    export default {

        components: { FieldError, MultiDropdownField, NumberField, TextareaField, TextField },

        computed: {

            agencyCompanies: {
                get() { return this.value.companies || [] },
                set(value) { this.updateValue('companies', value) }
            },

            dataDeliveryEmail: {
                get() { return this.value.dataDeliveryEmail },
                set(value) { this.updateValue('dataDeliveryEmail', value) }
            },

            isPurchaser: {
                get() { return this.value.isPurchaser },
                set(value) { this.updateValue('isPurchaser', value) }
            },

            isSupplier: {
                get() { return this.value.isSupplier },
                set(value) { this.updateValue('isSupplier', value) }
            },

            isPrepayment: {
                get() { return this.value.isPrepayment },
                set(value) { this.updateValue('isPrepayment', value) }
            },

            paymentTargetDays: {
                get() { return this.value.paymentTargetDays },
                set(value) { this.updateValue('paymentTargetDays', value) }
            },

            paymentDeadlineDays: {
                get() { return this.value.paymentDeadlineDays },
                set(value) { this.updateValue('paymentDeadlineDays', value) }
            },

        },

        created() {
            // Agency-Flag setzen, Unternehmen zu anderen Unternehmen in Relation steh
            this.isAgency = Array.isArray(this.value.companies) && this.value.companies.length > 0
            // Unternehmen laden falls bereits Agentur (z.B. beim Bearbeiten)
            if (this.isAgency) {
                this.$store.dispatch('companies/loadAll')
            }
        },

        data() {
            return { isAgency: false }
        },

        props: {

            companyModels: {
                type: Array,
                required: true
            },

            value: {
                type: Object,
                required: true
            }

        },

        methods: {

            updateValue(prop, value) {
                this.$emit('input', R.assoc(prop, value, this.value))
            },

            validate() {
                return this.$validate()
            }

        },

        validators: {

            dataDeliveryEmail(value) {
                return Validator.value(R.defaultTo('', value)).custom(() => {
                    if (this.isSupplier && Validator.isEmpty(value)) {
                        return 'Darf nicht leer sein. Bitte E-Mail angeben'
                    }
                }).email('Ungültiges Format. Bitte gültige E-Mail-Adresse angeben')
            },

            paymentTargetDays(value) {
                return Validator.value(R.defaultTo('', value)).custom(() => {
                    if (this.isPurchaser && R.defaultTo(0, value) <= 0) {
                        return 'Darf nicht leer sein. Bitte Zahlungsziel angeben'
                    }
                })
            },

            paymentDeadlineDays(value) {
                return Validator.value(R.defaultTo('', value)).custom(() => {
                    if (this.isSupplier && R.defaultTo(0, value) <= 0) {
                        return 'Darf nicht leer sein. Bitte Zahlungsfrist angeben'
                    }
                })
            },

            type(value) {
                return Validator.value(R.defaultTo('', value)).custom(() => {
                    if (R.not(this.isPurchaser || this.isSupplier || this.isAgency)) {
                        return 'Mindestens einen Unternehmenstypen auswählen'
                    }
                })
            },

        },


        watch: {

            isAgency(value) {
                if (value) {
                    // Unternehmen erst jetzt laden — lazy, nur wenn Agentur angehakt
                    this.$store.dispatch('companies/loadAll')
                } else {
                    this.updateValue('companies', [])
                }
            }

        }

    }

</script>
